import { NgModule } from '@angular/core';
import { S141gS141m01Component } from './s141g-s141m01.component';
import { SharedModule } from './../../shared.module';

@NgModule({
    imports: [SharedModule],
    exports: [],
    declarations: [S141gS141m01Component]
})
export class S141gModule { }

